export default __webpack_public_path__ + "static/media/julian-wan-WNoLnJo7tS8-unsplash.6d2f7b76.jpg";